import { render, staticRenderFns } from "./RecebimentoParcialFornecedor.vue?vue&type=template&id=4696e73f"
import script from "./RecebimentoParcialFornecedor.vue?vue&type=script&lang=js"
export * from "./RecebimentoParcialFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports